import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
export function MechanismSection() {
  return <section className="bg-navy-900 py-14 md:py-20 relative text-cream-50" data-id="element-190">
      <div className="container mx-auto px-4" data-id="element-191">
        <div className="max-w-[720px] mx-auto" data-id="element-192">
          <div className="flex items-center justify-center gap-3 mb-10" data-id="element-193">
            <div className="w-12 h-px bg-gold-500/30" data-id="element-194" />
            <div className="w-1.5 h-1.5 rotate-45 bg-gold-500/50" data-id="element-195" />
            <div className="w-12 h-px bg-gold-500/30" data-id="element-196" />
          </div>
          <FadeIn data-id="element-197">
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-white mb-8 text-center" data-id="element-198">
              Presentamos el "Protocolo de Vaciado Nocturno"
            </h2>
            <p className="text-lg text-cream-100/90 mb-8 leading-relaxed" data-id="element-199">
              Este sistema no depende de suerte ni de promesas vacías. Es una
              ejecución directa en 72 horas basada en 2 palancas que casi nadie
              combina:
            </p>
          </FadeIn>

          <FadeIn delay={0.1} data-id="element-200">
            <div className="space-y-6 mb-10" data-id="element-201">
              <div className="bg-navy-800 p-6 rounded-xl shadow-md border-l-4 border-gold-500" data-id="element-202">
                <h3 className="text-xl font-bold text-white mb-2" data-id="element-203">
                  Silencio químico nocturno:
                </h3>
                <p className="text-cream-100/80" data-id="element-204">
                  eliminar los 7 irritantes invisibles que disparan urgencia y
                  nicturia.
                </p>
              </div>
              <div className="bg-navy-800 p-6 rounded-xl shadow-md border-l-4 border-gold-500" data-id="element-205">
                <h3 className="text-xl font-bold text-white mb-2" data-id="element-206">
                  Vaciado completo:
                </h3>
                <p className="text-cream-100/80" data-id="element-207">
                  técnicas simples para que no te acuestes con "residuo" que te
                  despierta a la 1:30 AM.
                </p>
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-208">
            <p className="text-xl font-heading font-bold text-white text-center mb-10" data-id="element-209">
              Cuando apagas esos disparadores y vacías mejor, tu cuerpo puede
              entrar en sueño profundo, recuperar energía y dejar de vivir en
              modo supervivencia.
            </p>
            <div className="flex justify-center" data-id="element-210">
              <Button data-id="element-211">QUIERO APLICAR EL PROTOCOLO</Button>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}